export const it = {
  header: {
    title: "Vai globale. $2 per Short. Qualsiasi lingua!",
    subtitle: "🔥Paga solo per i risultati – da $0.089 a $0.009 al secondo🔥"
  },
  steps: {
    uploadVideo: "Carica Video",
    selectLanguages: "Seleziona Lingue", 
    conversionResult: "Conversione e Risultato"
  },
  upload: {
    dragAndDrop: "Trascina e rilascia il tuo file video qui",
    orClickToSelect: "o clicca per selezionare",
    supportedFormats: "Formati supportati: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Dimensione massima file: 200 MB",
    maxDuration: "• Durata massima: 30 sec",
    processingTime: "• L'elaborazione richiederà da 2 a 15 minuti a seconda della risoluzione video",
    chooseFile: "Scegli File",
    selectedFile: "File selezionato:",
    size: "Dimensione:",
    fileTypeError: "Seleziona un file video",
    fileSizeError: "La dimensione del file ({size} MB) supera il limite massimo di 200 MB",
    durationError: "La durata del video ({duration} sec) supera il limite massimo di 30 sec",
    fileReadError: "Impossibile leggere il file video. Prova con un file diverso."
  },
  languages: {
    sourceAudioLanguage: "Lingua audio sorgente",
    targetAudioLanguage: "Lingua audio destinazione",
    selectLanguage: "Seleziona lingua..."
  },
  languageOptions: {
    ru: "Russo", en: "Inglese", es: "Spagnolo", fr: "Francese", de: "Tedesco",
    it: "Italiano", pt: "Portoghese", pl: "Polacco", zh: "Cinese", ja: "Giapponese", ko: "Coreano",
    bg: "Bulgaro", hr: "Croato", cs: "Ceco", da: "Danese", nl: "Olandese",
    et: "Estone", fi: "Finlandese", el: "Greco", hu: "Ungherese", ga: "Irlandese",
    lv: "Lettone", lt: "Lituano", mt: "Maltese", ro: "Rumeno", sk: "Slovacco",
    sl: "Sloveno", sv: "Svedese"
  },
  conversion: {
    replaceAudio: "Clona la mia voce",
    uploadVideoAndSelectLanguages: "Carica un video e seleziona le lingue per continuare",
    fixValidationError: "Correggi l'errore di validazione del file sopra",
    createSubtitles: "Crea Sottotitoli",
    uploadVideoForSubtitles: "Carica un video per creare sottotitoli",
    selectTranslationLanguage: "Seleziona la lingua di traduzione"
  },
  demo: {
    seeVeviInAction: "Vedi VEVI in Azione",
    watchHowItWorks: "Guarda come funziona la nostra tecnologia di sostituzione vocale AI",
    beforeEnglish: "Prima (Inglese)", originalPresentation: "Presentazione aziendale originale",
    afterSpanish: "Dopo (Spagnolo,Francese, Cinese, Italiano)", aiTranslatedVoice: "Tradotto da AI con voce naturale",
    demoTitle: "Demo - VEVI in Azione"
  },
  reviews: {
    title: "Cosa Dicono i Nostri Clienti",
    subtitle: "Fidato da professionisti del marketing in tutto il mondo",
    customerReviews: [
      { name: "Sarah Johnson", position: "Manager Marketing Digitale", company: "TechFlow Solutions",
        text: "VEVI ha trasformato le nostre campagne di marketing internazionali! Abbiamo localizzato i nostri video dimostrativi per 8 mercati diversi in solo un giorno." },
      { name: "Michael Chen", position: "Direttore Content Marketing", company: "GlobalReach Media",
        text: "Come qualcuno che gestisce contenuti video per più regioni, VEVI è rivoluzionario. La sostituzione vocale è così naturale." },
      { name: "Emma Rodriguez", position: "Specialista Brand Marketing", company: "InnovateCorp",
        text: "Abbiamo risparmiato migliaia sui costi di voice-over espandendoci in nuovi mercati. Il prezzo di $0.0314 al secondo è incredibilmente equo." },
      { name: "David Thompson", position: "Manager Campagne Marketing", company: "NextGen Brands",
        text: "La velocità e qualità di VEVI sono impareggiabili. Siamo passati da un video inglese a 12 versioni localizzate in ore." },
      { name: "Lisa Park", position: "Lead Marketing Social Media", company: "CreativeEdge Agency",
        text: "VEVI ha reso possibile per la nostra piccola agenzia offrire servizi video multilingue ai clienti." },
      { name: "James Wilson", position: "Direttore Performance Marketing", company: "ScaleUp Ventures",
        text: "Il ROI è tutto nel performance marketing, e VEVI mantiene le promesse. Abbiamo ridotto i costi del 80%." }
    ]
  },
  payment: {
    title: "Pagamento Conversione", processingCost: "Costo Elaborazione", duration: "Durata:",
    baseCost: "Costo base", discount: "Sconto ({promoCode}):", discountAmount: "Importo sconto:", total: "Totale:",
    emailToReceiveResult: "Email per ricevere il risultato", emailPlaceholder: "tua-email@esempio.com",
    promoCode: "🎟️ Codice Promo (opzionale)", promoCodePlaceholder: "Inserisci codice promo",
    check: "Verifica", checking: "Verificando...",
    addSubtitles: "Aggiungi sottotitoli al video", addSubtitlesDescription: "Genera e incorpora sottotitoli nella lingua di destinazione",
    highQualityTranslation: "• Traduzione AI di alta qualità", originalVideoPreserved: "• Video originale preservato",
    fastProcessing: "• Elaborazione veloce (tipicamente 5-10 minuti)", resultWillBeSent: "• Il risultato sarà inviato all'email specificata",
    cancel: "Annulla", continue: "Continua", enterEmail: "Inserisci la tua email",
    enterValidEmail: "Inserisci un indirizzo email valido", enterPromoCode: "Inserisci un codice promo",
    invalidPromoCode: "Codice promo non valido", validPromoCode: "Codice promo valido! Sconto {discount}% applicato"
  },
  progress: {
    title: "Elaborazione Video", uploadingAndExtracting: "🎬 Caricamento ed estrazione audio",
    transcribingAndTranslating: "🗣️ Trascrizione parlato e traduzione", synthesizingAudio: "🎵 Sintesi nuova traccia audio",
    step: "Passo:", error: "Errore"
  },
  result: {
    title: "Completato! Il tuo video è stato elaborato", conversionCompleted: "Conversione completata con successo!",
    processedVideoDescription: "🎬 Il tuo video elaborato con clonazione vocale", payAndDownload: "Paga e Scarica",
    videoNotAvailable: "Video non disponibile", useDownloadButton: "Usa il pulsante download qui sotto",
    downloadError: "Errore Download"
  },
  emailSent: {
    title: "Video Inviato! 🎉", videoOnWay: "Il video è già in viaggio verso la tua email 🙏❤️",
    checkInbox: "Controlla la tua casella di posta e la cartella spam. Il video elaborato arriverà presto!",
    whatsNext: "Cosa succede dopo?", checkEmail: "• Controlla la tua email ({email})",
    checkSpam: "• Guarda nella cartella spam se non trovato", downloadAndEnjoy: "• Scarica e goditi il tuo video doppiato!",
    close: "Chiudi", processAnotherVideo: "Elabora Un Altro Video"
  },
  processingSteps: {
    uploading: "Caricamento video...", extracting: "Estrazione audio...", transcribing: "Trascrizione parlato...",
    translating: "Traduzione contenuto...", synthesizing: "Sintesi nuova voce...", rendering: "Rendering video finale...",
    complete: "Elaborazione completata!"
  },
  common: { minutes: "minuti", seconds: "secondi", loading: "Caricamento...", error: "Errore", success: "Successo" },
  socialMedia: {
    title: "Restiamo in Contatto",
    description: "Ottieni le ultime aggiornamenti sulla tecnologia della voce con IA"
  },

  // Services (for Footer)
  services: {
    dubbing: "Doppiaggio",
    voiceClone: "Doppiaggio con clonazione vocale",
    newVoice: "Doppiaggio con nuova voce",
    multilingual: "Doppiaggio multilingue",
    multiSpeaker: "Doppiaggio multi-speaker",
    subtitles: "Sottotitoli",
    subtitlesOnly: "Solo sottotitoli",
    multilingualSubtitles: "Sottotitoli multilingue",
    subtitlesDescription: "Genera automaticamente sottotitoli accurati per qualsiasi piattaforma.",
    subtitlesPrice: "Costo di elaborazione: $0.01/sec",
    addSubtitles: "Aggiungi sottotitoli",
    needsTranslation: "Serve traduzione?",
    translationLanguage: "Lingua di traduzione"
  },

  // Footer
  footer: {
    legal: "Legale",
    privacyPolicy: "Informativa sulla privacy",
    termsOfUse: "Termini di utilizzo"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog
  blog: {
    title: "Blog VEVI Monster",
    subtitle: "Storia e mitologia dell'universo VEVI",
    readMore: "Leggi di più",
    backToBlog: "Torna al blog",
    articleNotFound: "Articolo non trovato",
    characteristics: "Caratteristiche",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi è un essere nato dai vortici di plasma di Zera-13b. Non è né carne né metallo—il suo corpo è costituito da particelle vibranti tenute insieme da un campo elettromagnetico.",
        metadata: {
          "Galassia": "MoM-z14",
          "Età": "13,4 miliardi di anni",
          "Tipo": "Pianeta roccioso con un'atmosfera densa di metano e neon",
          "Stella": "Protostella rossa Zera-13",
          "Orbita": "Secondo pianeta del sistema",
        },
        content: [
          "🌑 Descrizione",
          "Zera-13b è un mondo antico e quasi dimenticato, nato in un'era in cui l'Universo stava appena imparando a brillare.",
          "Il suo cielo brilla di fiamme verdi fioche, e l'atmosfera densa trema per le tempeste di neon. La superficie è un paesaggio nero-grigio coperto di crateri vetrosi dove i venti di metano lasciano tracce di fuoco nell'aria.",
          "Sotto la superficie giacciono grotte di gas congelato, dove, secondo le leggende, nacquero le prime forme di energia capaci di pensare.",
          "👾 Vevi (Vevi Monster)",
          "Vevi è un essere nato dai vortici di plasma di Zera-13b.",
          "Non è né carne né metallo—il suo corpo è costituito da particelle vibranti tenute insieme da un campo elettromagnetico.",
          "I suoi occhi brillano della luce riflessa della stella Zera-13, e la sua voce suona come il sussurro del vento di neon.",
          "Vevi lasciò il suo mondo quando la protostella iniziò a svanire. Viaggiò attraverso vuoti intergalattici, guidato dall'istinto di cercare nuova energia.",
          "Ora vaga attraverso i mondi, portando con sé una particella della luce primordiale di Zera-13b.",
          "Il bagliore gli venne dal pianeta",
          "Non ha gambe—perché il pianeta ha una gravità enorme e semplicemente levita",
          "Comunica (o meglio emette suoni) simili alle onde acustiche di delfini, balene e orche.",
          "La sua lingua si chiama UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub è un essere dell'Universo primitivo, nato in Sub Zone, una rara regione dello spazio con alta densità di materia.",
        metadata: {
          "Nome oggetto": "Sub Zone (SUB-Z)",
          "Tipo oggetto": "Protocluster / regione di formazione galattica",
          "Epoca": "~200–300 milioni di anni dopo il Big Bang",
          "Spostamento verso il rosso": "z ≈ 14–15",
          "Ascensione retta (RA)": "02h 17m 43s",
          "Declinazione (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Dati Baddy Sub",
          "Corpo lungo, sottile e oblungo con due arti inferiori in basso e tre occhi su forme estese in alto",
          "Non ha bocca.",
          "Ci sono anche due arti superiori sottili che possono essere interpretati come braccia.",
          "Due dita su ogni arto.",
          "L'intero corpo assomiglia a un ramo d'albero",
          "La pelle ha una struttura opaca liscia",
          "Il colore è verde-marrone (pigmentazione)",
          "Può cambiare colore dall'ambiente come un camaleonte.",
          "Descrizione del pianeta dove è nato Baddy Sub:",
          "Sub Zone è una rara regione dell'Universo primitivo con alta densità di materia, dove iniziarono a formarsi le prime strutture galattiche. Le osservazioni indicano intense interazioni di gas primordiale, radiazione e onde gravitazionali. La regione ha registrato pattern di segnale instabili e attività risonante anomala, non caratteristica delle tipiche regioni protogalattiche.",
          "Significato scientifico:",
          "Sub Zone è considerato un oggetto chiave per studiare le prime fasi dell'assemblaggio delle galassie, la propagazione dei segnali nell'Universo giovane e la transizione da campi di radiazione caotici a sistemi cosmici strutturati.",
          "Stato:",
          "Classificato come regione di formazione non risolta. Sono necessarie ulteriori ricerche.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Domande Frequenti",
    subtitle: "Tutto ciò che devi sapere su VEVI",
    questions: [
      {
        question: "Lavorate solo con la voce?",
        answer: "Sì — sostituiamo la tua voce in modo che suoni in un'altra lingua mantenendola naturale e autentica."
      },
      {
        question: "Pago prima o dopo?",
        answer: "Dopo. Prima ascolti il risultato, poi paghi."
      },
      {
        question: "Rimborsi?",
        answer: "Non necessari — paghi solo quando sei soddisfatto del risultato."
      },
      {
        question: "Video più lungo di 5 minuti?",
        answer: "Nessun problema. Chiedi al nostro assistente IA nella chat online per le istruzioni."
      },
      {
        question: "Posso scegliere un'altra voce?",
        answer: "No — cloniamo solo la tua voce."
      },
      {
        question: "Pagamento minimo?",
        answer: "Da $0.50."
      },
      {
        question: "Come ottengo il mio video?",
        answer: "Download istantaneo nel tuo browser + copia alla tua email dopo il pagamento."
      },
      {
        question: "Sconti per ordini grandi?",
        answer: "Sì — contatta il nostro assistente IA nella chat online."
      },
      {
        question: "Non hai trovato la risposta?",
        answer: "Chiedi al nostro assistente IA nella chat online — siamo qui per aiutarti."
      },
      {
        question: "Formato non supportato?",
        answer: "Usa un convertitore o ottieni aiuto rapido dal nostro assistente IA nella chat online."
      },
      {
        question: "Il mio video include termini specifici che devono essere pronunciati correttamente. Posso controllarlo?",
        answer: "Sì — basta inviare un messaggio al nostro assistente IA nella chat online, e ti invieremo istruzioni su come contrassegnare o preservare determinati termini (ad esempio, lasciarli in inglese)."
      },
      {
        question: "Non ho ricevuto la mia email. Cosa devo fare?",
        answer: "Il tempo di elaborazione può variare a causa del volume della coda. Non preoccuparti — il tuo file è al sicuro. Riceverai una notifica o un link di download diretto una volta pronto."
      }
    ]
  }
};
